import { AfterViewInit, ElementRef, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AirportSearchResult } from '../../airport/models/airport-search-result.model';
import { BusinessFuel, FuelType } from '../../business/models/business-fuel.model';
import { Router } from '@angular/router';
import { GlobalSettingsService } from '../services/global-settings.service';
import { Source } from '../models/source.model';
var AirportSummaryCardComponent = /** @class */ (function () {
    function AirportSummaryCardComponent(_router, _globalSettingsService) {
        this._router = _router;
        this._globalSettingsService = _globalSettingsService;
        this.fuelType = FuelType._100LL;
        this.compact = false;
        this.interactive = false;
        this.airportMouseEnter = new EventEmitter();
        this.airportMouseLeave = new EventEmitter();
        this._touchStartX = null;
        this._touchStartY = null;
    }
    Object.defineProperty(AirportSummaryCardComponent.prototype, "identifier", {
        get: function () {
            if (this.airport.identifier != null && this.airport.identifier.toUpperCase().startsWith('ZZ')) {
                return '';
            }
            else {
                return '(' + this.airport.identifier + ')';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportSummaryCardComponent.prototype, "minFuel", {
        get: function () {
            var _this = this;
            if ((this.airport.fuel || []).length < 1) {
                return null;
            }
            var minFuel = this.airport.fuel
                .filter(function (f) {
                if (_this.fuelType === FuelType.JetA && (f.fuelType === FuelType.JetA || f.fuelType === FuelType.JetAPremix)) {
                    return true;
                }
                return f.fuelType === _this.fuelType;
            })
                .sort(function (f1, f2) { return f1.price - f2.price; })[0];
            return minFuel ? minFuel.price : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AirportSummaryCardComponent.prototype, "fuelTypeStr", {
        get: function () {
            return BusinessFuel.formatFuelType(this.fuelType);
        },
        enumerable: true,
        configurable: true
    });
    AirportSummaryCardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fuelTypeSubscription = this._globalSettingsService.fuelType.subscribe(function (fuel) {
            _this.fuelType = BusinessFuel.parseFuelType(fuel);
        });
    };
    AirportSummaryCardComponent.prototype.ngOnDestroy = function () {
        this.fuelTypeSubscription.unsubscribe();
    };
    AirportSummaryCardComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // Workaround to avoid having to double tap on the card to navigate to the airport detail page, without breaking
        // scrolling.
        this.linkEl.nativeElement.addEventListener('touchstart', function (e) { return _this.onTouchStart(e); }, { passive: true });
        this.linkEl.nativeElement.addEventListener('touchend', function (e) { return _this.onTouchEnd(e); }, { passive: true });
    };
    AirportSummaryCardComponent.prototype.onHover = function (hover) {
        if (hover) {
            this.airportMouseEnter.emit(this.airport);
        }
        else {
            this.airportMouseLeave.emit(this.airport);
        }
    };
    AirportSummaryCardComponent.prototype.onTouchStart = function (e) {
        var touch = e.changedTouches[0];
        if (touch) {
            this._touchStartX = touch.pageX;
            this._touchStartY = touch.pageY;
        }
    };
    AirportSummaryCardComponent.prototype.onTouchEnd = function (e) {
        // If the page coordinates of the touchend event are the same as touchstart, then navigate to the airport detail
        // page.
        if (this.isTap(e)) {
            if (this.airport.sourceId === Source.CaribbeanGuide || this.airport.sourceId === Source.BahamasGuide) {
                this._router.navigate(['/airports', this.airport.identifier, 'island']);
            }
            else {
                this._router.navigate(['/airports', this.airport.identifier]);
            }
        }
    };
    /**
     * Returns true if the page coordinates of the touch end event are the same as for touch start, indicating that the
     * action is a tap instead of scroll. (Note that binding to the "tap" event does not work - without setting passive
     * to true, it breaks scrolling, and without setting passive to true, the event never fires.)
     * @param {TouchEvent} e
     * @return {boolean}
     */
    AirportSummaryCardComponent.prototype.isTap = function (e) {
        var touch = e.changedTouches[0];
        return touch ? this._touchStartX === touch.pageX && this._touchStartY === touch.pageY : false;
    };
    return AirportSummaryCardComponent;
}());
export { AirportSummaryCardComponent };
